import { Injectable, NgModuleFactoryLoader, ApplicationRef } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Shell } from './shell';

@Injectable()
export class DialogGuard implements CanActivate {
    constructor(
        private shell : Shell,
        private router : Router,
        private loader: NgModuleFactoryLoader,
        private appRef : ApplicationRef
    ) {

    }

    canActivate(route : ActivatedRouteSnapshot, state : RouterStateSnapshot ) {
        let firstRoute = this.shell.firstRoute; 

        setTimeout(async () => {
            let routeName = route.data.dialog;
            if (route.data.fromModule && typeof route.data.fromModule === 'string')
                routeName = `${routeName}@${route.data.fromModule}`;

            if (firstRoute) {
                this.shell.animateToDialog("instant", routeName, route.params);
            } else {
                this.shell.showDialog(routeName, route.params);
            }
        }, 1);

        if (route.data.allowNavigate || firstRoute)
            return true;

        if (typeof window === 'undefined')
            this.router.navigateByUrl('/home');
        return false;
    }
}
